import {useCallback,memo} from 'react'

//styles
import 'devextreme/dist/css/dx.light.css';
import '../../styles/input/custom-input.css'
import '../../styles/input/custom-number-group-dropdown.css'

//components
import { NumberBox } from 'devextreme-react/number-box';
import { DropDownButton } from 'devextreme-react/drop-down-button';

import {
    Validator,
    RequiredRule,
  } from 'devextreme-react/validator';

const CustomGroupDropdown = ({label, value, setValue,requiredValue, dropdownValue, setDropdownValue,values,labelSize,isDisabled, min, max}) => {
  const onChangeValue = useCallback((data) => {
      setValue(data)
  }, []);
  const onChangeValueDropdown = useCallback((data) => {
        setDropdownValue(data.item)
    }, []);
  return (
    <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>
        <div className='button-group'>
            <NumberBox
                  value={value}
                  disabled={isDisabled}
                  valueChangeEvent="input"
                  onValueChange={onChangeValue}
                  min={min ?? null}
                  max={max ?? null}
            >
            {requiredValue &&
                <Validator>
                <RequiredRule message={`${label} is required`} />
                </Validator>
            }
            </NumberBox>
            <DropDownButton
                    items={values}
                    useSelectMode={true}
                    keyExpr="id"
                    displayExpr="name"
                    selectedItemKey={dropdownValue.id}
                    onSelectionChanged={onChangeValueDropdown}
            />
        </div>
    </div>
  )
}

export default memo(CustomGroupDropdown)